import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'op-schedule-queue',
    templateUrl: './schedule-queue.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduleQueueComponent {
}